import { React, useContext, useState } from "react";
import { AppContext } from "../../../../context/AppContext";
// import * as Buffer from 'buffer';
import { from } from 'buffer';
import step1 from "../../../../assets/images/step1.svg";
import step2 from "../../../../assets/images/step2.svg";
import borderStar from "../../../../assets/images/borderStar.svg";
import fillStar from "../../../../assets/images/fillStar.svg";
import flagLine from "../../../../assets/images/flagLine.svg";
import flagFill from "../../../../assets/images/flagFill.svg";
import { motion } from "framer-motion";
import MapComponent from "../../../../sharedComponent/MapComponent";
import { Button, Dropdown, Tab, Tabs, Spinner } from "react-bootstrap";
import Import from "../../../../assets/images/ic-Import.svg";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import { latestDate } from "../../../../sharedComponent/common";
import Select from "react-select";

import {
  multipartPostCall,
  simpleGetCall,
  simpleGetCallTime,
  simplePostCall,
} from "../../../../api/ApiServices";
import ApiConfig from "../../../../api/ApiConfig";
import { useEffect } from "react";
import Loader from "../../../../sharedComponent/Loader";
import { useTranslation } from "react-i18next";
import { DateDDMMYYYY, getTime } from "../../../../sharedComponent/common";
import { Link, useParams, useNavigate, json } from "react-router-dom";
import { Space, TimePicker } from "antd";
import { Modal, Tooltip } from "react-bootstrap";
import CommonSelect from "../../../../sharedComponent/ReactSelect";
import dayjs from "dayjs";
import { notifyError, notifySuccess } from "../../../../sharedComponent/notify";
import Form from "react-bootstrap/Form";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
const aninations = {
  initial: { opacity: 0, x: 400 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
};
const customStyles = {
  control: (base) => ({
    ...base,
    color: "#f6efe9",
    fontSize: 14,
    borderRadius: 10,
    border: "1px solid #f6efe9",
    backgroundColor: 'white',
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #f6efe9",
      // width : '13rem'
    },
    // This line disable the blue border
    boxShadow: "none",
  }),
};

const DispatchViewOrder = () => {
  const navigate = useNavigate();
  const {
    sidebar,
    ViewId,
    getTransporatioData,
    customerData,
    socket,
    timeZone,
    imageUrl,
    set_imageUrl,
    setDispatchStatus
  } = useContext(AppContext);
  const id = ViewId;
  const [loading, setLoading] = useState(false);
  const [pdf_flag, set_pdf_flag] = useState(false);

  // mqttconnections
  const [paramId, setParamId] = useState("");
  const { t, i18n } = useTranslation();
  let customerId = customerData.customer_id; //user_id
  const [orderDetails, setOrderDetails] = useState([]);
  console.log("orderDetails",orderDetails);
  
  const [liveVehicleDetails, setLiveVehicleDetails] = useState({});
  const [stopsData, setStopsData] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [modelstats, setModelstats] = useState(false);
  const [routingData, setRoutingData] = useState({
    trip_start_time: dayjs(new Date()).format("HH:mm:ss"),
    trip_end_time: "",
    vehicle_id: "",
  });
  const [errMsg, setErrMsg] = useState({
    trip_end_time: "",
    trip_start_time: "",
    vehicle_id: "",
  });

  const [OptionDownload, setOptionDownload] = useState("");
  const [pdf_link, set_pdf_link] = useState("");
  const [no_data_found, set_no_data_found] = useState(false);
  const isLastRow = sessionStorage.getItem('isLastRow');
  const isFirstRow = sessionStorage.getItem('isFirstRow');


  const ids = {
    pickup_point_id: sessionStorage.getItem('pickup_point_id'),
    dispatch_package_id: localStorage.getItem('dispatch_package_id'),
    pickup_point_trip_id: localStorage.getItem('pickup_point_trip_id'),
  }

  //  invoice tble data 
  const [invoiceTableData, setInvoiceTableData] = useState([]);




  // console.log("sessionstorage_pickup_point_id -->", pickup_point_id)
  console.log(' ids --->', ids)

  // useEffect(() => {
  //   if (id) {
  //     getOrderDetails();
  //   }
  //   // getTransporatioData();
  //   if(timeZone){

  //     getVehicleList();
  //   }
  // }, [id,timeZone]);
  const statusMap = {
    "0": "Order Received",
    "1": "Delivery Person Assigned",
    "2": "Order Dispatched",
    "3": "Ready to Delivery",
    "4": "Payment Done",
    "5": "Order Delivered",
    "6": "Returned",
    "7": "Return Back to Warehouse",
    "8": "Driver Reached For Pickup",
    "9": "Driver Reached For Delivery",
    "10": "Cancelled"
  };
  const handleInvoiceClick = (imageUrl, invoiceTableData, invoiceNo, pickuppoints_details_id) => {
    console.log("checking the invoice table =========", invoiceTableData);
    localStorage.setItem("invoiceTableData", JSON.stringify(invoiceTableData));
    localStorage.setItem("invioceNo", invoiceNo)
    localStorage.setItem("pickuppoints_details_id", pickuppoints_details_id);
    navigate('/ViewInvoice')

    set_imageUrl(imageUrl);

  }

  // useEffect(() => {
  //   getOrderDetails();


  // }, [])



  // const getOrderDetails = () => {
  //   setLoading(true);
  //   // simpleGetCall(ApiConfig.GET_ORDER_DETAILS + id )
  //   simplePostCall(ApiConfig.GET_DISPATCHEXECUTIVE_VIEW_ORDER_DETAILS ,)
  //     .then((res) => {
  //       if (res.result) {
  //         setOrderDetails(res?.data);
  //         setStopsData(res?.timeLineData);
  //         let vehicle_id = res.data?.trip_vehicle_id;
  //         getLiveVehicleApi({
  //           user_customer_id: Number(customerId),
  //           vehicleId: vehicle_id,
  //         });

  //         getOrderListTime(
  //           [
  //             Number(res?.data?.vendor_warehouse_longitude),
  //             Number(res?.data?.vendor_warehouse_latitude),
  //           ].join(","),
  //           [
  //             Number(res?.data?.dispatch_customer_address_longitude),
  //             Number(res?.data?.dispatch_customer_address_latitude),
  //           ].join(",")
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // let newId=useParams()
  // let paramID=newId?.id
  // console.log("paramID",paramID);

  // var ID=useParams()
  // var pickup_point_id_to_use_in_api=ID?.pickup_point_id

 

  useEffect(() => {

    getDispatchOrderDetails();

  }, [])


  const getDispatchOrderDetails_with_pdf = () => {
    setLoading(true);
    let body = JSON.stringify({
      pickup_point_id: ids?.pickup_point_id,
      pickup_point_trip_id: ids?.pickup_point_trip_id,
      format: 'pdf'
    }
    )
    // simplePostCall(ApiConfig?.GET_DISPATCH_SINGLE_VEHICLE, JSON.stringify(body))
    simplePostCall(ApiConfig?.GET_DISPATCHEXECUTIVE_VIEW_ORDER_DETAILS, body)
      .then((res) => {

        if (res.result) {
          const firstKey = res.pdf;
          setOrderDetails(res?.data);
          set_pdf_link(firstKey);


          if (res?.data?.length === 0) {
            set_no_data_found(true);
          }


        } else {

          set_no_data_found(true)
        }
      })
      .catch((err) => {
        set_no_data_found(true)
        console?.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDispatchOrderDetails = () => {
    setLoading(true);
    let body = JSON.stringify({
      pickup_point_id: ids?.pickup_point_id,
      pickup_point_trip_id: ids?.pickup_point_trip_id,
      format: ''
    }
    )
    // simplePostCall(ApiConfig?.GET_DISPATCH_SINGLE_VEHICLE, JSON.stringify(body))
    simplePostCall(ApiConfig?.GET_DISPATCHEXECUTIVE_VIEW_ORDER_DETAILS, body)
      .then((res) => {
        if (res.result) {
          // const firstKey = res.pdf;
          setOrderDetails(res?.data);
          // sessionStorage.setItem('pickuppoints_details_id', res?.data[0]?.pickuppoints_details_id)
          // set_pdf_link(firstKey);
          if (res?.data?.length === 0) {
            set_no_data_found(true);
          }


        } else { set_no_data_found(true) }
      })
      .catch((err) => {
        set_no_data_found(true)
        console?.log(err);
      })
      .finally(() => {
        setLoading(false);
        setSingleInvoiceUpdateDisableButton(true)
      });
  };

  //  const handleDownloadPdf = () => {

  // if (pdf_link !== ""){
  //   window.open(pdf_link)
  // } 





  // }, [pdfData]);
  const getDispatchOrderDetails_with_pdf_1 = () => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      let body = JSON.stringify({
        pickup_point_id: ids?.pickup_point_id,
        pickup_point_trip_id: ids?.pickup_point_trip_id,
        format: 'pdf'
      });

      simplePostCall(ApiConfig?.GET_DISPATCHEXECUTIVE_VIEW_ORDER_DETAILS, body)
        .then((res) => {
          if (res.result) {
            setOrderDetails(res?.data);
            if (res?.data?.length === 0) {
              set_no_data_found(true);
            }
            resolve(res);  // Resolve the promise when the data is set
          } else {
            set_no_data_found(true);
            reject(new Error('No data found'));
          }
        })
        .catch((err) => {
          set_no_data_found(true);
          console?.log(err);
          reject(err);  // Reject the promise on error
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const handleDownloadPdf_1 = async () => {
    try {
      const res = await getDispatchOrderDetails_with_pdf_1();

      if (res && res.pdf) {
        const pdf_link = res.pdf;  // Assuming res.pdf is where the PDF link is stored

        const response = await fetch(pdf_link);
        const blob = await response.blob();
        const url = window?.URL?.createObjectURL(new Blob([blob]));

        const a = document.createElement("a");
        a.href = url;

        const fileName = pdf_link.substring(pdf_link.lastIndexOf("/") + 1);
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window?.URL?.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDownloadPdf = () => {
    getDispatchOrderDetails_with_pdf();

    if (pdf_link) {
      fetch(pdf_link)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window?.URL?.createObjectURL(new Blob([blob]));

          const a = document.createElement("a");
          a.href = url;

          // Extract the file name from the filepath dynamically
          const fileName = pdf_link.substring(pdf_link.lastIndexOf("/") + 1);
          a.download = fileName;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window?.URL?.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error downloading file:", error));
    }
  };

  /* const getLiveVehicleApi = (body) => {
    setLoading(true);
    // simplePostCall(ApiConfig?.GET_DISPATCH_SINGLE_VEHICLE, JSON.stringify(body))
    simplePostCall(ApiConfig?.GET_DISPATCHEXECUTIVE_VIEW_ORDER_DETAILS, JSON.stringify(body))
      .then((res) => {
        if (res?.result === true) {
          setLiveVehicleDetails(res?.data[0]);
          setParamId(res.data[0]?.vehicle_imei);
        } else {
          setLiveVehicleDetails({});
        }
      })
      .catch((err) => {
        console?.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }; */

  useEffect(() => {
    if (paramId && timeZone) {
      const dataSingle = {
        user_customer_id: customerId,
        imei: paramId,
        timeZone: timeZone,
      };
      socket && socket.emit("singleVehicle", dataSingle);
      socket &&
        socket.on(`${paramId}`, (data) => {
          setLiveVehicleDetails(data[0]);
        });
    }
  }, [paramId, timeZone]);

  //assign order

  const handalevalidation = () => {
    if (routingData?.vehicle_id?.length === 0) {
      setErrMsg({
        ...errMsg,
        vehicle_id: "Please Select Vehicle ",
      });
      return;
    }
    // if (routingData?.trip_start_time?.length === 0) {
    //   setErrMsg({
    //     ...errMsg,
    //     trip_start_time: "Please Enter  start Time"

    //   });
    //   return;
    // }

    // if ( routingData?.trip_end_time?.length === 0) {
    //   setErrMsg({
    //     ...errMsg,
    //     trip_end_time: "Please Enter valid End Time ",

    //   });
    //   return;
    // }
    setLoading1(true);
    let body = JSON.stringify({
      ...routingData,
      order_id: id,
      orderDetails: orderDetails,
      // drowtype: layerTypeSend,
      // drowradius: radius,
      // drowvalue: mapLatLngData,
      timeZone: timeZone,
      vehicle_id: routingData?.vehicle_id,
    });
    simplePostCall(ApiConfig.ADD_MANUAL_ROUTING_VIEW, body)
      .then((res) => {
        setLoading1(false);
        if (res.result) {
          notifySuccess(res.message);
          setModelstats(false);
          getDispatchOrderDetails();
          // getOrderDetails();
          // navigate("/TripManagement");
          setRoutingData({
            trip_end_time: "",
            trip_start_time: "",
            vehicle_id: "",
          });
        } else {
          notifyError(res.message);
        }
      })
      .catch((errr) => {
        console.log("errr", errr);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getVehicleList = () => {
    setLoading(true);
    simplePostCall(ApiConfig.MANUAL_VEHICLE_LIST, JSON.stringify({ timeZone: timeZone }))
      .then((res) => {
        setVehicleList(res?.data);
        let vehicles = res?.data;
        var grades = [];
        vehicles?.map((grade, index) => {
          grades?.push({
            label: grade?.vehicle_number,
            value: grade?.vehicle_id,
          });
        });
        setGradeState({ ...gradeState, grades: grades });
      })
      .catch((err) => {
        console?.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  let driver = vehicleList?.filter(
    (driver) => driver.vehicle_id == routingData?.vehicle_id
  )[0];
  const [gradeState, setGradeState] = useState({
    grades: [],
  });
  const handleModel = (props) => {
    setModelstats(props);
  };
  const handleCancle = () => {
    notifySuccess("Order Cancel For Now");
  };

  const getOrderListTime = (startPoint, EndPoint) => {
    simpleGetCallTime(
      `https://routing.openstreetmap.de/routed-car/route/v1/driving/${startPoint};${EndPoint}?overview=false&alternatives=true&steps=false`
    )
      .then((res) => {
        if (res.code == "Ok") {
          const route = res.routes[0];
          // const distance = route.summary.totalDistance; // in meters

          const currentTime = new Date()
            .toLocaleTimeString("en-US", { timeZone, hour12: false })
            .split(" ")[0];
          const time = new Date(Date.now() + route?.duration * 1000)
            .toLocaleTimeString("en-US", { timeZone, hour12: false })
            .split(" ")[0];
          // setEndSendTime(time)

          setRoutingData({ ...routingData, trip_start_time: currentTime, trip_end_time: time });
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // ////////////////////////////////////////////////////////////////////////////////
  const [deleveryDetails_new, setDeleveryDetails_new] = useState({
      device_new: "web",
      time_new: dayjs(new Date()).format("HH:mm:ss"),
      dispatch_package_order_datetime_new: new Date(),
      milk_run_vehicle_no: "",
      milk_run_vehicle_id: "",
      escort_name: "",
      milk_run_route: "",
      start_km_for_milk_run: "",
      supplier_name: "",
      po_no: "",
      invoice_no: "",
      item_code: "",
      quantity: "",
      basic_value: "",
      value_with_taxes: "",
      photo_of_material: "",
      start_km_supplier: "",
      end_km_supplier: "",
      in_time_supplier: "0",
      out_time_supplier: "0",
      check_in_dispatch_customer: "",
      check_out_dispatch_customer: "",
      end_km_based_location: "",
      km_reading: "",
      material_received_by: "",
      vehicle_utilization: "",
      customer_gate_entery: "",
      description: "",
      remark: "",
      invoice_photo: "",
      material_photo: "",
      gate_pass_photo: "",
      vehicle_weight_slip_photo: "",
      pick_up_address: "",
      delivery_address: "",
      start_trip_with_start_time: "",
      end_trip_with_end_time: "",
      milk_start_odo: "",
      milk_end_odo: "",
      milk_start_odo_img: "",
      milk_end_odo_img: "",
      material_weight: "",
    });
  const [singleInvoiceUpdateDisableButton, setSingleInvoiceUpdateDisableButton] = useState(true)
  const [singleInvoiceUpdateSaveButtonLoading, setSingleInvoiceUpdateSaveButtonLoading] = useState(false)
  const [showUpdateInvoice, setShowUpdateInvoice] = useState(false)
  const [singleInvoiceUpdate, setSingleInvoiceUpdate] = useState({
    pickuppoints_details_invoice_img : '',
    pickuppoints_details_id : '',
    pickuppoints_details_po_no: ''

  })
 const [secondLoader, setSecondLoader] = useState(false);
  const [invoicePhotosAndOcrData, setInvoicePhotosAndOcrData] = useState([{
    image: null,
    imageOrcData: null,
    filteredItems: [],
    totalValue: 0,
  }]);

  const handleAddPhoto = () => {
    setInvoicePhotosAndOcrData(prev => [...prev, {
      image: null,
      imageOrcData: null,
      filteredItems: [],
    }]);
  };

  const handleDeletePhoto = (index) => {
    if (invoicePhotosAndOcrData?.length > 1) { // Prevent deleting the last input
      // console.log("checking handle delete")
      setInvoicePhotosAndOcrData(prev => prev.filter((item, i) => i != index));
    }
  };
  const handleFileChange = (event, index) => {
    const file = event.target.files[0];



    // console.log("checking the handle change");

    // handle the empty image
    // if (file) {
    //   setInvoicePhotosAndOcrData(prev => {
    //     const data = [...prev];
    //     data[index] = {
    //       image: file,
    //       imageOrcData: null,
    //       filteredItems: [],
    //       totalValue: 0,
    //       invoiceNo: ""
    //     }
    //     return data;
    //   })
    //   notifyError("Please upload proper invoice");
    //   return;
    // }

   

    // feth the Ocr data of the image  and the update the state 
    getImageOcr(file, index, event, false);
  };
const [ocrItemsForSingleUpdate , setOcrItemsForSingleUpdate] = useState([])
const [ocrSingleInvoiceNo , setOcrSingleInvoiceNo] = useState('')

  function getImageOcr(img, index, event, singleEdit) {
    setSecondLoader(true)
    // set loader true 
    const formData = new FormData();
    formData.append('img_url', img);

    multipartPostCall(ApiConfig?.GET_INVOIC_DETAILS, formData)
      .then((res) => {
        if (res.success) {

          // convert the string to the array of object 
          const itemCodes = res?.invoice?.[0]?.items.map((item) => {
            const splitItems = item.item.split(' ');

            let um = item?.umPo?.split(' ')

            

            let po = um.slice(1).join(' ')

            const obj = {
              SrNo: splitItems[0],
              item_code: item.itemCode,
              item_type: item.item_type,
              item_description: item?.itemName,
              item_um: um[0],
              item_pono: po,
              SrNo2: splitItems[6],
              item_quantity: item?.quantity,
              item_rate: item?.price
            }
            // first update the total value 

            // add zeros max at four position
            return obj;
          });

if(singleEdit){
  setOcrItemsForSingleUpdate(itemCodes)
  setOcrSingleInvoiceNo(res?.invoice?.[0]?.SuplrInvNo)
  setSingleInvoiceUpdateDisableButton(false)
} else {

          // console.log("checking item filter ==============", itemCodes);
          setInvoicePhotosAndOcrData(prev => {
            const data = [...prev];
            data[index] = {
              image: img,
              imageOrcData: res,
              filteredItems: itemCodes,
              totalValue: res?.invoice?.[0]?.Total,
              invoiceNo: res?.invoice?.[0]?.SuplrInvNo,
            }
            return data;
          });
        }
        } else {
          notifyError("Please upload proper invoice");
          event.target.value = null;
          setInvoicePhotosAndOcrData(prev => {
            const data = [...prev];
            data[index] = {
              image: null,
              imageOrcData: null,
              filteredItems: [],
              totalValue: 0,
              invoiceNo: ""
            }
            return data;
          });
        }
      })
      .catch((err) => {
        console?.log(err);
        notifyError("Please upload proper invoice");
        setInvoicePhotosAndOcrData(prev => {
          const data = [...prev];
          data[index] = {
            image: null,
            imageOrcData: null,
            filteredItems: [],
            totalValue: 0,
            invoiceNo: ""
          }
          return data;
        });
      })
      .finally(() => {
        setSecondLoader(false);
      });
  }


  const handleUpdateInvoiceClick =(index)=>{
    // setShowUpdateInvoice(!showUpdateInvoice)
    setShowUpdateInvoice((prev) => (prev === index ? null : index));
  }

  const handelInvoiceTableItemChange = (e, parentIndex, childeIndex) => {
      const { name, value } = e.target;
      // here we go dip into the state for example
      /*[
         {
          fileredItems:[
          {
          spacific itme: and its value;
          }
          
          ]
         }
      ]*/
      setInvoicePhotosAndOcrData(prev => {
        // get all the data 
        const data = [...prev];
        // select the tageted index second data 
        const childData = [...data[parentIndex].filteredItems];
        // get all the data of the second data's targeted items 
        const item = {
          ...childData[childeIndex],
          // modify the specific value 
          [name]: value
        }
  
  
  
  
        // assige the new item to second data 
        childData[childeIndex] = item;
  
  
        // calculate the total value
        let totalValue = 0;
  
        childData.map((item) => {
          if (item.Rate) {
            totalValue += (Number(item.Rate) * Number(item.Quantity));
          }
        })
  
        totalValue = totalValue.toFixed(4);
  
        // assign the second data to the first 
        data[parentIndex] = {
          ...data[parentIndex],
          filteredItems: childData,
          totalValue: totalValue
        }
  
  
        // console.log("checking the state update ============", data);
        // assign the modified data to the state
        return data;
      })
  
      // console.log("checking====name ", name, " vlaue ========= ", value);
    }
    const handleInvoiceChange = (e, index) => {
      setInvoicePhotosAndOcrData(prev => {
        const data = [...prev];
        const item = {
          ...data[index],
          invoiceNo: e.target.value
        }
        data[index] = {
          ...item
        }
        return data;
      })
    }
    async function getResult(data) {
      return JSON.parse(data.trim());
    }

    function sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    }
    
    const handleSingleInvoiceDataUpdate = async (event) => {

     
      
      

  let body = JSON.stringify({
      pickuppoints_details_invoice_no: ocrSingleInvoiceNo,
      pickuppoints_details_id: singleInvoiceUpdate.pickuppoints_details_id,
     
      pickuppoints_details_po_no: '',
    
      items: JSON.stringify(ocrItemsForSingleUpdate)
    }
    )
   await  simplePostCall(ApiConfig.UPDATE_INVOIC_DETAILS, body)
      .then(data => {
        console.log('UPdatedata--->', data)
        if (data?.result) {
          // navigate('/DispatchViewOrder')
          notifySuccess(data?.message)
          // setDeleteModal(false)
          // getVechicleAccident(1)
          // setPage(1)
        } else {
          notifyError(data?.message)
        }
      })
      .catch(error => {
        console.log('api response-->', error)
      }).finally(()=>{
        setSingleInvoiceUpdateSaveButtonLoading(false)
      })

     
    }
    const handleSingleInvoiceUpdate = async (event) => {
     
      event.preventDefault();
      const form = event.currentTarget;
      // setLoading(true);
      setSingleInvoiceUpdateSaveButtonLoading(true)
      if (form.checkValidity() === false) {
        event.stopPropagation();
      } else {
       


        const formData = new FormData();
      
        formData.append('pickuppoints_details_id',singleInvoiceUpdate.pickuppoints_details_id);
        formData.append('pickuppoints_details_invoice_img',singleInvoiceUpdate.pickuppoints_details_invoice_img);
     multipartPostCall(ApiConfig.POST_UPDATE_SINGLE_INVOICE,formData)
          .then( async (res) => {
            if (res.result) {
              // notifySuccess(res.message);
             await handleSingleInvoiceDataUpdate()
             await sleep(500)
             getDispatchOrderDetails()
          
            
            } else {
              notifyError(res.message);
            }
          })
          .catch((err) => console.log(err));
      }
    }
const [loadingForAddingInvoice, setLoadingForAddingInvoice] = useState(false)
 
    const handleSubmitForDispatch = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        // setLoading(true);
    
        if (form.checkValidity() === false) {
          event.stopPropagation();
        } else {
          setLoadingForAddingInvoice(true);
          let body = JSON.stringify({
            ...deleveryDetails_new,
            dispatch_package_order_datetime_new: `${latestDate(
              deleveryDetails_new?.dispatch_package_order_datetime_new,
              "yyyy-MM-dd"
            )} T ${deleveryDetails_new?.time_new}`,
          });
    
    //       if (remark?.length === 0) {
    //         setMerchentSelectError('Please Select Merchent Collection')
    //         setLoading(false)
    //         return
    //       }
    // 
    // 
    //       let remarksList = remark.map((rmk) => {
    //         return rmk?.details
    //       })
    
          // if its last stop 
    //       if (isLastRow == 1) {
    //         console.log("i got hit")
    //         const formData = new FormData();
    // 
    // 
    // 
    // 
    //         formData.append('remark', JSON.stringify(remarksList))
    //         formData.append('pickup_point_id', ids?.pickup_point_id);
    //         formData.append('vehicle_id', deleveryDetails_new?.milk_run_vehicle_id);
    //         formData.append('pickuppoints_details_route', deleveryDetails_new?.milk_run_route);
    //         formData.append('pickuppoints_details_start_kilometer_milk_run', deleveryDetails_new?.start_km_for_milk_run);
    //         // formData.append('pickuppoints_details_po_no', PoNo);
    //         // formData.append('pickuppoints_details_invoice_no', invoiceNo);
    //         // formData.append('pickuppoints_details_item_code', item_code);
    //         // formData.append('pickuppoints_details_quantity', item_quantity);
    //         // formData.append('pickuppoints_details_basic_value', item_rate);
    //         // formData.append('pickuppoints_details_value_with_taxes', deleveryDetails_new?.value_with_taxes);
    //         // formData.append('pickuppoints_details_img_item', deleveryDetails_new?.material_photo);
    //         // formData.append('pickuppoints_details_invoice_img', data.image ? data.image : null);
    //         formData.append('pickuppoints_details_vehicle_weight_img', deleveryDetails_new?.vehicle_weight_slip_photo);
    //         formData.append('pickuppoints_details_get_pass_img', deleveryDetails_new?.gate_pass_photo);
    //         formData.append('pickuppoints_details_start_kilometer_supplier', deleveryDetails_new?.start_km_supplier);
    //         formData.append('pickuppoints_details_end_kilometer_supplier', deleveryDetails_new?.end_km_supplier);
    //         formData.append('pickuppoints_details_in_time_supplier', deleveryDetails_new?.in_time_supplier);
    //         formData.append('pickuppoints_details_out_time_supplier', deleveryDetails_new?.out_time_supplier);
    //         formData.append('pickuppoints_details_check_in_dcustomer', deleveryDetails_new?.check_in_dispatch_customer);
    //         formData.append('pickuppoints_details_check_out_dcustomer', deleveryDetails_new?.check_out_dispatch_customer);
    //         formData.append('pickuppoints_details_end_kilometer_based_location', deleveryDetails_new?.end_km_based_location);
    //         formData.append('pickuppoints_details_kilometer_reading', deleveryDetails_new?.km_reading);
    //         formData.append('pickuppoints_details_received_by', deleveryDetails_new?.material_received_by);
    //         formData.append('pickuppoints_details_vehicle_utilization', deleveryDetails_new?.vehicle_utilization);
    //         formData.append('pickuppoints_details_gate_entry', deleveryDetails_new?.customer_gate_entery);
    //         formData.append('pickuppoints_details_item_desc', deleveryDetails_new?.description);
    //         formData.append('pickuppoints_details_item_remark', deleveryDetails_new?.remark);
    //         formData.append('pickuppoints_details_trip_id', ids?.pickup_point_trip_id);
    //         formData.append('pickuppoints_details_dispatch_id', ids?.dispatch_package_id);
    //         formData.append('tsb_pickuppoints_end_odometer', deleveryDetails_new?.milk_end_odo);
    //         formData.append('tsb_pickuppoints_end_odometer_img', deleveryDetails_new?.milk_end_odo_img);
    //         formData.append('tsb_pickuppoints_material_weight', deleveryDetails_new?.material_weight);
    //         formData.append("items", JSON.stringify([]));
    // 
    // 
    // 
    // 
    // 
    //         vehiclePhotos.forEach((element, index) => {
    //           if (element !== null) {
    //             formData.append("pickuppoints_details_vehicle_img", element);
    //           }
    //         })
    // 
    //         // console.log(formData);
    //         // for (let [key, value] of formData.entries()) {
    //         //   console.log(`${key}:`, value);
    // 
    //         multipartPostCall(paramID ? ApiConfig.UPDATE_ORDER : ApiConfig.GET_POST_DISPATCHEXECUTIVE_NEW_ORDER, formData)
    //           .then((res) => {
    //             console.log(res);
    //             notifySuccess("On Trip stop add details successfully");
    //             navigate("/TripManagement");
    // 
    //           })
    //           .catch((err) => {
    //             console.log(err);
    //             notifyError("Something went wrong")
    //           }).finally(() => {
    //             setLoading(false);
    //           })
    //         return;
    //       }
    // 
    //       // is its not the last stop
    // 
    // 
    
          const apiCalls = invoicePhotosAndOcrData.map(async (data, index) => {
    
    
    
            const items = data?.filteredItems?.map(item => ({
              item_code: item.item_code,
              item_type: '',
              item_description: item.item_description,
              item_pono: item.item_pono,
              item_rate: parseFloat(item.item_rate),
              item_quantity: parseFloat(item.item_quantity),
              item_um: item.item_um
            }));
    
            const tempItem = items[0];
            const invoiceNo = data?.invoiceNo;
            const PoNo = tempItem.item_pono ? tempItem.item_pono : "";
            const item_code = tempItem.item_code ? tempItem.item_code : '';
            const item_quantity = tempItem.item_quantity ? tempItem.item_quantity : "";
            const item_rate = tempItem.item_rate ? tempItem.item_rate : "";
    
    console.log("testing_items-->", data?.filteredItems) 
  
    
            const formData = new FormData();
            // formData.append('remark',JSON.stringify(rderDetails?.remark[0]))
            formData.append('remark',JSON.stringify('hiii'))
            formData.append('tsb_pickuppoints_material_collection_date',orderDetails[0]?.tsb_pickuppoints_material_collection_date)
            formData.append('matrial_date', latestDate(new Date(), 'yyyy-MM-dd'))
            formData.append('pickup_point_id', orderDetails[0]?.pickup_point_id);
            formData.append('vehicle_id', orderDetails[0]?.vehicle_id);
            formData.append('pickuppoints_details_route', orderDetails[0]?.pickuppoints_details_route);
            formData.append('pickuppoints_details_start_kilometer_milk_run', orderDetails[0]?.pickuppoints_details_start_kilometer_milk_run);
            formData.append('pickuppoints_details_po_no', PoNo);
            formData.append('pickuppoints_details_invoice_no', invoiceNo);
            formData.append('pickuppoints_details_item_code', item_code);
            formData.append('pickuppoints_details_quantity', item_quantity);
            formData.append('pickuppoints_details_basic_value', item_rate);
            formData.append('pickuppoints_details_value_with_taxes', orderDetails[0]?.pickuppoints_details_value_with_taxes);
            formData.append('pickuppoints_details_img_item', orderDetails[0]?.pickuppoints_details_img_item);
            formData.append('pickuppoints_details_invoice_img', data.image ? data.image : null);
            formData.append('pickuppoints_details_vehicle_weight_img', orderDetails[0]?.pickuppoints_details_vehicle_weight_img);
            formData.append('pickuppoints_details_get_pass_img', orderDetails[0]?.pickuppoints_details_get_pass_img);
            formData.append('pickuppoints_details_start_kilometer_supplier', orderDetails[0]?.pickuppoints_details_start_kilometer_supplier);
            formData.append('pickuppoints_details_end_kilometer_supplier', orderDetails[0]?.pickuppoints_details_end_kilometer_supplier);
            formData.append('pickuppoints_details_in_time_supplier', orderDetails[0]?.pickuppoints_details_in_time_supplier);
            formData.append('pickuppoints_details_out_time_supplier', orderDetails[0]?.pickuppoints_details_out_time_supplier);
            formData.append('pickuppoints_details_check_in_dcustomer', orderDetails[0]?.pickuppoints_details_check_in_dcustomer);
            formData.append('pickuppoints_details_check_out_dcustomer', orderDetails[0]?.pickuppoints_details_check_out_dcustomer);
            formData.append('pickuppoints_details_end_kilometer_based_location', orderDetails[0]?.pickuppoints_details_end_kilometer_based_location);
            formData.append('pickuppoints_details_kilometer_reading', orderDetails[0]?.pickuppoints_details_kilometer_reading);
            formData.append('pickuppoints_details_received_by', orderDetails[0]?.pickuppoints_details_received_by);
            formData.append('pickuppoints_details_vehicle_utilization', orderDetails[0]?.pickuppoints_details_gate_entry);
            formData.append('pickuppoints_details_gate_entry', orderDetails[0]?.pickuppoints_details_gate_entry);
            formData.append('pickuppoints_details_item_desc', orderDetails[0]?.pickuppoints_details_item_desc);
            formData.append('pickuppoints_details_item_remark', orderDetails[0]?.pickuppoints_details_item_remark);
            formData.append('pickuppoints_details_trip_id', orderDetails[0]?.pickuppoints_details_trip_id);
            formData.append('pickuppoints_details_dispatch_id', orderDetails[0]?.pickuppoints_details_dispatch_id);
            formData.append("items", JSON.stringify(items));
    
    //         if (isFirstRow == 1) {
    //           formData.append('tsb_pickuppoints_start_odometer_img', orderDetails[0]?.milk_start_odo_img);
    //           formData.append('tsb_pickuppoints_start_odometer', orderDetails[0]?.milk_start_odo);
    // 
    //         }
            return await fetch(false ? ApiConfig.UPDATE_ORDER : ApiConfig.GET_POST_DISPATCHEXECUTIVE_NEW_ORDER, {
              method: "POST",
              headers: {
                Accept: "application/json",
                Authorization: localStorage.getItem("api_key"),
                user_customer_id: localStorage.getItem("customer_id"),
                user_id: localStorage.getItem("id")
              },
              body: formData,
            }).then(response => response.text())
              .then(result => getResult(result));
          });
    
          try {
            const results = await Promise.all(apiCalls);
    
            const allSuccessful = results.every(res => res.result);
    
            if (allSuccessful) {
              setDispatchStatus("pending");
              localStorage.setItem("dispatchKey", "pending");
              notifySuccess("On Trip stop add details successfully");
              setInvoicePhotosAndOcrData(  [{
                image: null,
                imageOrcData: null,
                filteredItems: [],
                totalValue: 0,
              }])
              getDispatchOrderDetails()
              // navigate("/TripManagement");
            } else {
              const failedResults = results.filter(res => !res.result);
              notifyError("Something went wrong.");
            }
          } catch (error) {
            notifyError('Something went wrong.');
            console.error("Error:", error);
          } finally {
            setLoadingForAddingInvoice(false);
          }
        }
        // setValidated(true);
      };
  return (
    <>
      <motion.div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
        variants={aninations}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1 }}
      >
        <div id="cx-wrapper" className="View_Orders">
          {loading ? (
            <Loader />
          ) : (
            <>
              {/* <div
                className="main-master-wrapper form_input_main"
                id="View_Dispatch_main"
              > */}
              {/*  <div className="headingDetails">
                  <div className="headingTxt">
                    <p className="heading">{t("Order Summary")}</p>
                  </div>
                  {orderDetails?.dispatch_package_status == 0 && (
                    <div className="innerSelectBox weekCounter selectForm form_input_main">
                      <button
                        className="AddAccidentLink"
                        onClick={() => {
                          getOrderListTime(
                            [
                              Number(orderDetails?.vendor_warehouse_longitude),
                              Number(orderDetails?.vendor_warehouse_latitude),
                            ].join(","),
                            [
                              Number(orderDetails?.dispatch_customer_address_longitude),
                              Number(orderDetails?.dispatch_customer_address_latitude),
                            ].join(",")
                          );
                          handleModel(true);
                        }}
                      >
                        {t("Assign Trip")}
                      </button>
                    </div>
                  )}
                </div> */}

              {/* ====================== Stepper start ===================== */}

              {/* <div className="vertical-stepper-main-wrapper">
                  <div class="">
                    <!-- completed -->
                    <div class="step completed">
                      <div class="v-stepper">
                        <div class="circle">
                          <img src={step1} alt="" />
                        </div>
                        <div class="line"></div>
                      </div>

                      <div class="content">
                        <label className="head">{t("Pick-Up Location")}</label>
                        <p className="Value">
                          {orderDetails?.vendor_warehouse_address ?? "-"}
                        </p>
                        <span className="DispatchSPan">
                          Ordered On{" "}
                          { orderDetails?.dispatch_package_order_datetime &&DateDDMMYYYY(
                            orderDetails?.dispatch_package_order_datetime ?? "-"
                          )}
                          {"  "}
                          {getTime(
                            orderDetails?.dispatch_package_order_datetime ?? "-"
                          )}
                        </span>
                      </div> */}
          

              {/* {stopsData?.map((ele, index) => {
                      return (
                        <div class="step completed" key={"stop" + index}>
                          <div class="v-stepper">
                            <div class="circle">
                              <img src={step2} alt="" />
                            </div>
                            <div className="line"></div>
                          </div>
                          

                          <div class="content">
                            <p className="head" style={{ fontSize: "18px", color: "#8f4300", fontWeight: 600 }}>
                              


                                {ele?.dispatch_package_activity_status == "0"
                                        ? "Order Received"
                                        : ele?.dispatch_package_activity_status == "1"
                                        ? "Delivery Person Assigned"
                                        : ele?.dispatch_package_activity_status == "2"
                                        ? "Order Dispatched"
                                        : ele?.dispatch_package_activity_status == "3"
                                        ? "Rready to Delivery"
                                        : ele?.dispatch_package_activity_status == "4"
                                        ? "Payment Done"
                                        : ele?.dispatch_package_activity_status == "5"
                                        ? "Order Delivered"
                                        : ele?.dispatch_package_activity_status == "6"
                                        ? "Returned"
                                        : ele?.dispatch_package_activity_status == "7"
                                        ? "Return Back to Warehouse"
                                        : ele?.dispatch_package_activity_status == "8"
                                        ? "Driver Reached For Pickup "
                                        : ele?.dispatch_package_activity_status == "9"
                                        ? "Driver Reached For Delivery"
                                        : ele?.dispatch_package_activity_status == "10"
                                        ? "cancelled"
                                        : ""} */}

              {/*    {ele?.dispatch_package_activity_status == "0" ? "Order Received":"" }
                                        {ele?.dispatch_package_activity_status == "1" ? "Delivery Person Assigned":"" }
                                        {ele?.dispatch_package_activity_status == "2" ? "Order Dispatched":"" }
                                        {ele?.dispatch_package_activity_status == "3" ? "Rready to Delivery":"" }
                                        {ele?.dispatch_package_activity_status == "4" ? "Payment Done":"" }
                                        {ele?.dispatch_package_activity_status == "5" ? "Order Delivered":"" }
                                        {ele?.dispatch_package_activity_status == "6" ? "Returned":"" }
                                        {ele?.dispatch_package_activity_status == "7" ? "Return Back to Warehouse":"" }
                                        {ele?.dispatch_package_activity_status == "8" ? "Driver Reached For Pickup":"" }
                                        {ele?.dispatch_package_activity_status == "9" ? "Driver Reached For Delivery":"" }
                                        {ele?.dispatch_package_activity_status == "10" ? "cancelled":"" }*/}

              {/* </p> */}

              {/* <span className="DispatchSPan">
                              {ele?.dispatch_package_activity_date}{" "}
                              {ele?.dispatch_package_activity_time}
                            </span>{" "}
                          </div>
                       
                      
                        </div>
                        
                      );
                    })} */}
              {/* <div class="step completed">
                      <div class="v-stepper">
                        <div class="circle">
                          <img src={step1} alt="" />
                        </div>
                        <div class="line"></div>
                      </div>

                      <div class="content">
                        <label className="head">{t("Drop Location")}</label>
                        <p className="Value">
                          {orderDetails?.dispatch_customer_address_address ??
                            "-"}
                        </p>
                   {orderDetails.trip_end_date&&     <span className="DispatchSPan">
                          {t("Expected Delivery by ")}

                          {`${orderDetails?.trip_end_date?DateDDMMYYYY(orderDetails?.trip_end_date):"" }  ${orderDetails?.trip_end_time?orderDetails?.trip_end_time:""}`}
                        </span>}
                      </div>
                      <div className="content pl-2 " >
                          <div className="d-flex flex-column">
                        <div>
                        
                        </div>
                       
                        </div> */}
              {/*  <p className="dateInn"> {DateDDMMYYYY(tripDetails.trip_date)}{" "}
                            {"  "}
                            {tripDetails.trip_start_time}</p> */}
              {/* </div> */}
              {/* <div className="content ">
                          <div className="d-flex flex-column">
                        <div>
                      
                        </div>
                       
                        </div> */}
              {/*  <p className="dateInn"> {DateDDMMYYYY(tripDetails.trip_date)}{" "}
                            {"  "}
                            {tripDetails.trip_start_time}</p> */}
              {/* </div> */}


              {/* </div>
                  </div>
                </div> */}
              {/* ====================== Stepper end ===================== */}
              {/* </div> */}
              {no_data_found && orderDetails?.length === 0 && <NoDataComp />}
              {orderDetails.map((orderDetails, index) => (
                <div className="mb-5">

                  <div
                    className="main-master-wrapper form_input_main"
                    id="View_Dispatch_main"
                  >
                    <div className="headingDetails">
                      <div className="headingTxt">
                        <p className="heading">{t("Order Details")}</p>
                      </div>
                      <div className="leftContent d-flex">
                        <div class="btn-wrapper">
                          {(!no_data_found && index === 0) &&
                            <button class="cx-btn-2 mb-1" onClick={handleDownloadPdf_1}>
                              {t("Download PDF")}
                            </button>}
                        </div>



                      </div>
                    </div>


                    {no_data_found ? <NoDataComp />
                      :
                      (


                        <div className="DetailsSec">
                          <div className="row">
                            {/* <div className="col-3">
                      <label className="head">{t("Material Collection Date")}</label>
                      <p className="Value">
                        {orderDetails?.vehicle_number ?? "-"}
                      </p>
                    </div> */}
                            <div className="col-md-3 col-12">
                              <label className="head">{t("Milk Run Vehicle No.")}</label>
                              <p className="Value">
                                {orderDetails?.vehicle_number ?? "-"}
                              </p>
                            </div>
                            <div className="col-md-3 col-12">
                              <label className="head">{t("Milk Run Route")}</label>
                              <p className="Value">{orderDetails?.pickuppoints_details_route ?? "-"}</p>
                            </div>
                            <div className="col-md-3 col-12">
                              <label className="head">{t("Start KM For Milk Run.")}</label>
                              <p className="Value">{orderDetails?.pickuppoints_details_start_kilometer_milk_run ?? "-"}</p>
                            </div>{" "}

                            {/* <div className="col-md-3 col-12">
                                <label className="head">{t("PO No.")}</label>
                                <p className="Value">{orderDetails?.pickuppoints_details_po_no ?? "-"}</p>
                              </div> */}
                            {isLastRow != 1 &&
                              <div className="col-md-3 col-12">
                                <label className="head">{t("Invoice No.")}</label>
                                <p className="Value">
                                  {orderDetails?.pickuppoints_details_invoice_no ?? "-"}
                                </p>
                              </div>}

                            {/* <div className="col-md-3 col-12">
                                <label className="head">{t("Item Code")}</label>
                                <p className="Value">
                                  {orderDetails?.pickuppoints_details_item_code ?? "-"}
                                </p>
                              </div> */}
                            {/* <div className="col-md-3 col-12">
                                <label className="head">{t("Quantity.")}</label>
                                <p className="Value">
                                  {orderDetails?.pickuppoints_details_quantity ?? "-"}
                                </p>
                              </div> */}
                            {/* <div className="col-md-3 col-12">
                              <label className="head">{t("Basic Value.")}</label>
                              <p className="Value">
                                {orderDetails?.pickuppoints_details_basic_value ?? "-"}
                              </p>
                            </div> */}

                            <div className="col-md-3 col-12">
                              <label className="head">{t("Value With Taxes.")}</label>
                              <p className="Value">
                                {orderDetails?.pickuppoints_details_value_with_taxes ?? "-"}
                              </p>
                            </div>
                            <div className="col-md-3 col-12">
                              <label className="head">{t("Start KM Supplier")}</label>
                              <p className="Value">
                                {orderDetails?.pickuppoints_details_start_kilometer_supplier ?? "-"}
                              </p>
                            </div>
                            <div className="col-md-3 col-12">
                              <label className="head">{t("End KM Supplier")}</label>
                              <p className="Value">
                                {orderDetails?.pickuppoints_details_end_kilometer_supplier ?? "-"}
                              </p>
                            </div>


                            {isLastRow != 1 && <>

                              <div className="col-md-3 col-12">
                                <label className="head">{t("In Time Supplier")}</label>
                                <p className="Value">
                                  {(orderDetails?.pickuppoints_details_in_time_supplier && orderDetails?.pickuppoints_details_in_time_supplier !== "undefined")   ? orderDetails?.pickuppoints_details_in_time_supplier : "-"}
                                </p>
                              </div>


                              <div className="col-md-3 col-12">
                                <label className="head">{t("Out Time Supplier")}</label>
                                <p className="Value">
                                  {(orderDetails?.pickuppoints_details_out_time_supplier && orderDetails?.pickuppoints_details_out_time_supplier !== 'undefined') ? orderDetails?.pickuppoints_details_out_time_supplier : "-"}
                                </p>
                              </div>
                            </>
                            }


                            {isLastRow == 1 &&
                              <>
                                <div className="col-md-3 col-12">
                                  <label className="head">{t("Check In Dispatch Customer")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_check_in_dcustomer ?? "-"}
                                  </p>
                                </div>
                                <div className="col-md-3 col-12">
                                  <label className="head">{t("Check Out Dispatch Customer")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_check_out_dcustomer ?? "-"}
                                  </p>
                                </div>
                                <div className="col-md-3 col-12">
                                  <label className="head">{t("End KM Based Location")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_end_kilometer_based_location ?? "-"}
                                  </p>
                                </div>
                                <div className="col-md-3 col-12">
                                  <label className="head">{t("KM Reading")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_kilometer_reading ?? "-"}
                                  </p>
                                </div>
                                <div className="col-md-3 col-12">
                                  <label className="head">{t("Material Received By")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_received_by ?? "-"}
                                  </p>
                                </div>
                                <div className="col-md-3 col-12">
                                  <label className="head">{t("Vehicle Utilization")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_vehicle_utilization ?? "-"}
                                  </p>
                                </div>
                              </>
                            }
                            {isLastRow == 1 && <div className="col-md-3 col-12">
                              <label className="head">{t("Customer Gate Entery")}</label>
                              <p className="Value">
                                {orderDetails?.pickuppoints_details_gate_entry ?? "-"}
                              </p>
                            </div>}


                            {
                              isLastRow == 1 ? (
                                <div className="col-md-3 col-12 mt-2">
                                  <label className="head">{t("Material Weight In Kg")}</label>
                                  <p className="Value">
                                    {orderDetails?.tsb_pickuppoints_material_weight ?? "-"}
                                  </p>
                                </div>
                              ) : (
                                <div className="col-md-3 col-12 mt-2">
                                  <label className="head">{t("Description")}</label>
                                  <p className="Value">
                                    {orderDetails?.pickuppoints_details_item_desc ?? "-"}
                                  </p>
                                </div>
                              )
                            }
                            {isFirstRow == 1 &&
                              <div className="col-md-3 col-12 mt-2">
                                <label className="head">{t("Milk Start Odo Meter Reading")}</label>
                                <p className="Value">
                                  {orderDetails?.tsb_pickuppoints_start_odometer ?? "-"}
                                </p>
                              </div>
                            }
                            {isLastRow == 1 &&
                              <div className="col-md-3 col-12 mt-2">
                                <label className="head">{t("Milk End Odo Meter Reading")}</label>
                                <p className="Value">
                                  {orderDetails?.tsb_pickuppoints_end_odometer ?? "-"}
                                </p>
                                </div>
                              }
                                <div className="col-md-3 col-12 mt-2">
                                  <label className="head">{t(`${isLastRow==1?"Customer":"Merchant"} Collection Remarks`)}</label>
                                  <div>
                                    {
                                      orderDetails&&orderDetails?.remark&&orderDetails?.remark.map((i,indx)=>{
                                        return <p className="Value">{indx+1} : {i?.remarks_details_name}</p>
                                      })
                                    }
                                  </div>
                                  
                                </div>
                                <div className="col-md-3 col-12 mt-2">
                                <label className="head">{t("Trip Date")}</label>
                                <p className="Value">
                                  {DateDDMMYYYY(orderDetails?.trip_date ?? "-")}
                                </p>
                                </div>
                                <div className="col-md-3 col-12 mt-2">
                                <label className="head">{t("Supplier Name")}</label>
                                <p className="Value">
                                  {orderDetails?.vendor_name ?? "-"}
                                </p>
                                </div>
                              </div>
                            
                          
                        </div>
                      )}
                  </div>


                  {no_data_found ? <> </>
                    :
                    (



                      <div
                        className="main-master-wrapper form_input_main"
                        id="View_Dispatch_main"
                      >
                        <div className="headingDetails">
                          <div className="headingTxt">
                            <p className="heading">{t("Uploaded Photos")}</p>
                          </div>
                        </div>
                        <div className="DetailsSec">
                          <div className="row">
{/* ///////////////////////////////////////////////////////////////////////////////////////// */}
{index === 0  && (
                <Form onSubmit={handleSubmitForDispatch}>
                  
                      <div className="AddNewForm">
                        
                        <Form.Label className="common-labels ms-2">
                         Upload Invoice
                        </Form.Label>
                        {invoicePhotosAndOcrData.map((data, index) => (
                              <div className="col-12 d-md-flex" key={index} /*style={{ display: 'flex'
        }} */>
                                <div className="col-md-6 col-9 ">
                                  <Form.Control
                                    required
                                    accept="image/png,image/jpeg"
                                    type="file"
                                    placeholder="Browse Image"
                                    name={`invoice_photo_${index}`} // Use unique name for each input
                                    onChange={(event) => handleFileChange(event, index)}
                                  />

                                </div>
                                <div className="col-md-2 col-3">
                                  {invoicePhotosAndOcrData?.length > 1 && index > 0 ? ( // Show delete button only for additional inputs
                                    <Button className=" btn-sm btn-dark" type="button" size="small" onClick={() => handleDeletePhoto(index)} style={{ backgroundColor: '#9C4900' }}>
                                      Delete
                                    </Button>
                                  ) : invoicePhotosAndOcrData?.length > 0 && (
                                    <Button className="btn btn-sm btn-dark" type="button" size="small" onClick={handleAddPhoto} style={{ backgroundColor: '#9C4900' }}>
                                      Add
                                    </Button>
                                  )}
                                </div>
                                <div className="col-md-4 col-6">
                                  {data.image && (
                                    <img
                                      style={{ width: '9rem', height: '5rem', marginLeft: '1rem' }}
                                      src={URL.createObjectURL(data.image)}
                                      alt={`Invoice Photo ${index + 1}`}
                                    />
                                  )}
                                </div>
{console.log("invoicePhotosAndOcrData-->",invoicePhotosAndOcrData)}
                              </div>
                    ))}
                    <div className="col mb-4 DetailsSec" id="View_Dispatch_main">
                    {
                      invoicePhotosAndOcrData?.map((data, parentIndex) => {
                        return (<>
                          {secondLoader && <Loader />}
                         
                          {
                          
                             data.image 
                            &&
                            <div className="mb-2" key={parentIndex} >
                              <h3>Invoice {parentIndex + 1}</h3>
                              <div className="row">
                                <p>Invoice no :-
                                  <input
                                    // onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                    className="edatiableInputInvoice"
                                    type="text"
                                    name="SrNo"
                                    onChange={(e) => handleInvoiceChange(e, parentIndex)}
                                    value={data?.invoiceNo}
                                  />
                                </p>
                                <div className="table-responsive">
                                  <table className="holiday-table table" >
                                    <thead className="ht-head text-center">
                                      <tr>
                                        <td>{t("Sr.No.")}</td>
                                        <td>{t("Item Code")}</td>
                                        <td>{t("Item Description")}</td>
                                        <td>{t("UM")}</td>
                                        <td>{t("PO No")}</td>
                                        {/* <td>{t("Sr No")}</td> */}
                                        <td>{t("Quantity")}</td>
                                        <td>{t("Rate")}</td>

                                      </tr>
                                    </thead>
                                    <tbody className="ht-body text-center">

                                      {
                                        
                                        data?.filteredItems?.map((item, childeIndex) => {
                                          return (<tr className="table-row-custom" key={"listadat" + childeIndex}>
                                            <td>

                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                type="text"
                                                name="SrNo"
                                                value={childeIndex + 1}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                name="ItemCode"
                                                type="text"
                                                value={item?.item_code}
                                              />
                                            </td>
                                            <td >
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                name="ItemDescription"
                                                type="text"
                                                value={item?.item_description}
                                              />
                                            </td>
                                            <td >
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                type="text"
                                                name="UM"
                                                value={item?.item_um}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                               style={{width:"300px"}}
                                                type="text"
                                                name="PONo"
                                                value={item?.item_pono}
                                              />
                                            </td>
                                            {/* <td>
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                name="SrNo2"
                                                type="text"
                                                value={item?.SrNo2}
                                              />
                                            </td> */}
                                            <td>
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                type="text"
                                                name="Quantity"
                                                value={item?.item_quantity} />
                                            </td>
                                            <td>
                                              <input
                                                onChange={(e) => handelInvoiceTableItemChange(e, parentIndex, childeIndex)}
                                                className="edatiableInputInvoice"
                                                type="text"
                                                name="Rate"
                                                value={item?.item_rate}
                                              />
                                            </td>
                                          </tr>)
                                        })
                                      }
                                    </tbody>

                                    <tfooter className="bg-primary text-end" >
                                    </tfooter>
                                  </table>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-2" >
                                <div className="Value"> Total Value :  {data?.totalValue}</div>
                                <div className="Value mx-3">  </div>
                              </div>
                            </div>
                          }
                        </>)
                      })
                    }
                  </div>
                  <div className ='d-flex justify-content-end'>
                    <button className="cx-btn-2" type="submit" disabled={loadingForAddingInvoice}>
                  {loadingForAddingInvoice ? <Spinner/> :  t("Submit")}
                    </button> 
                    </div>

</div>
   


                
</Form>
)}

{/* /////////////////////////////////////////////////////////////////////////////////////////////// */}
                            <div className="invoice-photo-container"> {/* Wrap for clarity */}
                              <label className="head">{isLastRow == 1 ? t("Vehicle Photo 1") : t("Invoice Photo")}</label>


                              {
                                isLastRow == 1 ? <>
                                  {orderDetails?.snap_path?.map((imageUrl, index) => (
                                    <div key={index} className="col-md-6 col-lg-6 col-xl-4 col-12">
                                    
                                      {/* <Link to="/ViewInvoice"> */}
                                      <img
                                        style={{
                                          width: "23rem",
                                          height: "14rem",
                                          marginTop: "1rem",
                                          objectFit: "cover",
                                          cursor: "pointer"
                                        }}
                                        src={imageUrl}
                                        // onClick={() => handleInvoiceClick(imageUrl, orderDetails.items, orderDetails?.pickuppoints_details_invoice_no, orderDetails?.pickuppoints_details_id)}

                                        alt={"Vehicle Photo 1"}
                                      />
                                      {/* </Link> */}
                                    </div>

                                  ))}
                                </> : <>
                                {/* taleeb */}
                                  {orderDetails?.pickuppoints_details_invoice_img?.map((imageUrl, index2) => (
                                    <div key={index2} className="col-md-6 col-lg-6 col-xl-4 col-12">

<Button className="btn btn-sm btn-dark"   onClick={() => handleInvoiceClick(imageUrl, orderDetails.items, orderDetails?.pickuppoints_details_invoice_no, orderDetails?.pickuppoints_details_id)} type="button" size="small" style={{ backgroundColor: '#9C4900' }}>
                                      Details
                                    </Button>
                                    <Button className="btn btn-sm btn-dark ms-3"   onClick={() => handleUpdateInvoiceClick(index)} type="button" size="small" style={{ backgroundColor: '#9C4900' }}>
                                      Update
                                    </Button>
                                    {console.log('testing_index2-->', index)}
{showUpdateInvoice === index     && (
                                       <div className="col-md-12 col-sm-12 colForm mt-2">
                                       <Form onSubmit={handleSingleInvoiceUpdate} className='d-flex justify-content-start align-items-end'>
                                       <div>
                                                              <Form.Label className="common-labels">
                                                                {t("Upload Invoice")}
                                                              </Form.Label>
                                                              <Form.Control className=""
                                                                    required
                                                                    accept="image/png, image/gif, image/jpeg"
                                                                    type="file"
                                                                    placeholder="Browse"
                                                                    name="material_photo"
                                                                    onChange={(e,index2) => {
                                                                      setSingleInvoiceUpdate({
                                                                        pickuppoints_details_id : orderDetails?.pickuppoints_details_id,
                                                                        pickuppoints_details_invoice_img: e.target.files[0],
                                                                        pickuppoints_details_po_no: orderDetails?.pickuppoints_details_id
                                                                    });
                                                                    getImageOcr(e.target.files[0], index2, e, true);
                                                                    }}
                                                                  />
                                    
                                                                  {/* {tripCompletion?.odometerEndKmPhoto && (
                                                                    <img
                                                                      style={{
                                                                        width: "9rem",
                                                                        height: "5rem",
                                                                        marginTop: "1rem",
                                                                        objectFit: "cover",
                                                                      }}
                                                                      src={
                                                                        typeof tripCompletion?.odometerEndKmPhoto ===
                                                                          "string"
                                                                          ? `${ApiConfig.BASE_URL}${tripCompletion?.odometerEndKmPhoto}`
                                                                          : tripCompletion?.odometerEndKmPhoto &&
                                                                          URL?.createObjectURL(
                                                                            tripCompletion?.odometerEndKmPhoto
                                                                          )
                                                                      }
                                                                      alt="img not found"
                                                                    />
                                                                  )} */}
                                    
                                    
                                                              <Form.Control.Feedback type="invalid">
                                                                {t("Please upload invoice")}
                                                              </Form.Control.Feedback>
                                                              </div>
                                                              <Button disabled={singleInvoiceUpdateDisableButton || singleInvoiceUpdateSaveButtonLoading}  className="btn btn-sm btn-dark ms-2 mb-1"    type="submit" size="small" style={{ backgroundColor: '#9C4900' }} >
                                      {singleInvoiceUpdateSaveButtonLoading ? <Spinner/> : 'Save'}
                                    </Button>
                                                              </Form>
                                                          
                                                            </div>
)} 
                                      {/* <Link to="/ViewInvoice"> */}
                                      <img
                                        style={{
                                          width: "23rem",
                                          height: "14rem",
                                          marginTop: "1rem",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                          display:'block'
                                        }}
                                        src={imageUrl}
                                        onClick={() => handleInvoiceClick(imageUrl, orderDetails.items, orderDetails?.pickuppoints_details_invoice_no, orderDetails?.pickuppoints_details_id)}

                                        alt={"Invoice Photo"}
                                      />
                                      {/* </Link> */}
                                    </div>

                                  ))} 
                                  {/* taleeb */}
                                </>
                              }

                            </div>

                            {isLastRow != 1 &&
                              <div className="col-md-6 col-lg-6 col-xl-4 col-12">
                                <label className="head">{t("Material Photo")}</label>

                                <div>
                                  {orderDetails?.pickuppoints_details_img_item && (
                                    <img
                                      style={{
                                        width: "20rem",
                                        height: "14rem",
                                        marginTop: "1rem",
                                        objectFit: "cover",
                                      }}
                                      src={orderDetails?.pickuppoints_details_img_item
                                        // typeof orderDetails?.pickuppoints_details_img_item ===
                                        // "string"
                                        //   ? `${ApiConfig.BASE_URL}${orderDetails?.pickuppoints_details_img_item}`
                                        //   : orderDetails?.pickuppoints_details_img_item &&
                                        //     URL.createObjectURL(
                                        //       orderDetails?.pickuppoints_details_img_item
                                        //     )
                                      }
                                      alt="img not found"
                                    />
                                  )}
                                </div>

                              </div>
                            }

                            {isFirstRow == 1 &&

                              <div className="col-md-6 col-lg-6 col-xl-4 col-12">
                                <label className="head">{t("Milk Start Odo Meter Reading Photo")}</label>

                                <div>
                                  {orderDetails?.tsb_pickuppoints_start_odometer_img && (
                                    <img
                                      style={{
                                        width: "20rem",
                                        height: "14rem",
                                        marginTop: "1rem",
                                        objectFit: "cover",
                                      }}
                                      src={orderDetails?.tsb_pickuppoints_start_odometer_img
                                        // typeof orderDetails?.pickuppoints_details_img_item ===
                                        // "string"
                                        //   ? `${ApiConfig.BASE_URL}${orderDetails?.pickuppoints_details_img_item}`
                                        //   : orderDetails?.pickuppoints_details_img_item &&
                                        //     URL.createObjectURL(
                                        //       orderDetails?.pickuppoints_details_img_item
                                        //     )
                                      }
                                      alt="img not found"
                                    />
                                  )}
                                </div>

                              </div>
                            }
                            {isLastRow == 1 &&
                              <div className="col-md-6 col-lg-6 col-xl-4 col-12">
                                <label className="head">{t("Gate Pass Photo")}</label>

                                <div>
                                  {orderDetails?.pickuppoints_details_get_pass_img && (
                                    <img
                                      style={{
                                        width: "20rem",
                                        height: "14rem",
                                        marginTop: "1rem",
                                        objectFit: "cover",
                                      }}
                                      src={orderDetails?.pickuppoints_details_get_pass_img

                                        // typeof orderDetails?.pickuppoints_details_get_pass_img ===
                                        // "string"
                                        //   ? `${ApiConfig.BASE_URL}${orderDetails?.pickuppoints_details_get_pass_img}`
                                        //   : orderDetails?.pickuppoints_details_get_pass_img &&
                                        //     URL.createObjectURL(
                                        //       orderDetails?.pickuppoints_details_get_pass_img
                                        //     )
                                      }
                                      alt="img not found"
                                    />
                                  )}
                                </div>
                              </div>
                            }

                            {isLastRow == 1 &&
                              <div className="col-md-6 col-lg-6 col-xl-4 col-12">
                                <label className="head">{t("Weight Slip Photo")}</label>

                                <div>
                                  {orderDetails?.pickuppoints_details_vehicle_weight_img && (
                                    <img
                                      style={{
                                        width: "23rem",
                                        height: "14rem",
                                        marginTop: "1rem",
                                        objectFit: "cover",
                                      }}
                                      src={orderDetails?.pickuppoints_details_vehicle_weight_img

                                        // typeof orderDetails?.pickuppoints_details_get_pass_img ===
                                        // "string"
                                        //   ? `${ApiConfig.BASE_URL}${orderDetails?.pickuppoints_details_get_pass_img}`
                                        //   : orderDetails?.pickuppoints_details_get_pass_img &&
                                        //     URL.createObjectURL(
                                        //       orderDetails?.pickuppoints_details_get_pass_img
                                        //     )
                                      }
                                      alt="img not found"
                                    />
                                  )}
                                </div>
                              </div>
                            }
                             {isLastRow == 1 &&
                              <div className="col-md-6 col-lg-6 col-xl-4 col-12">
                                <label className="head">{t("Milk End Odo Meter Reading Photo")}</label>

                                <div>
                                  {orderDetails?.tsb_pickuppoints_end_odometer_img && (
                                    <img
                                      style={{
                                        width: "23rem",
                                        height: "14rem",
                                        marginTop: "1rem",
                                        objectFit: "cover",
                                      }}
                                      src={orderDetails?.tsb_pickuppoints_end_odometer_img

                                        // typeof orderDetails?.pickuppoints_details_get_pass_img ===
                                        // "string"
                                        //   ? `${ApiConfig.BASE_URL}${orderDetails?.pickuppoints_details_get_pass_img}`
                                        //   : orderDetails?.pickuppoints_details_get_pass_img &&
                                        //     URL.createObjectURL(
                                        //       orderDetails?.pickuppoints_details_get_pass_img
                                        //     )
                                      }
                                      alt="img not found"
                                    />
                                  )}
                                </div>
                              </div>
                            }
                            {/* <div className="col-md-4">
                      <label className="head">
                        {t("Customer Rating")} (*
                        {t("After Delivery of Product")})
                      </label>
                      <div className="d-flex">
                        <img src={fillStar} className="me-1" alt="" />
                        <img src={fillStar} className="me-1" alt="" />
                        <img src={fillStar} className="me-1" alt="" />
                        <img src={borderStar} className="me-1" alt="" />
                        <img src={borderStar} className="me-1" alt="" />
                      </div>
                    </div> */}
                          </div>
                        </div>
                      </div>

                    )
                  }

                </div>
              ))
              }





              {/* <div
                className="main-master-wrapper form_input_main"
                id="View_Dispatch_main"
              >
                <div className="headingDetails">
                  <div className="headingTxt">
                    <p className="heading">{t("Order Details")} </p>
                  </div>
                </div>
                <div className="DetailsSec">
                  <div className="row">
                    <div className="col-3">
                      <label className="head">{t("Order Number")} </label>
                      <p className="Value">
                        {orderDetails?.dispatch_package_order_number ?? "-"}
                      </p>
                    </div>
                    <div className="col-3">
                      <label className="head">{t("Order Date & Time")} </label>
                      <p className="Value">
                        {DateDDMMYYYY(
                          orderDetails?.dispatch_package_order_datetime ?? "-"
                        )}
                        {"  "}
                        {getTime(
                          orderDetails?.dispatch_package_order_datetime ?? "-"
                        )}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <label className="head">{t("Amount")} </label>
                      <p className="Value">
                        {orderDetails.dispatch_package_order_amount ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <label className="head">{t("Payment Type")} </label>
                      <p className="Value">
                        {orderDetails?.dispatch_package_order_payment_mode ??
                          "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <div
                className="main-master-wrapper form_input_main"
                id="View_Dispatch_main"
              >
                <div className="headingDetails">
                  <div className="headingTxt">
                    <p className="heading">{t("Trip Details")} </p>
                  </div>
                </div>
                <div className="DetailsSec">
                  <div className="row">
                    <div className="col-3">
                      <label className="head">{t("Trip Name")} </label>
                      <p className="Value">
                        {orderDetails?.trip_name ?? "-"}
                      </p>
                    </div>
                   
                    <div className="col-md-2">
                      <label className="head">{t("Trip Id")} </label>
                      <p className="Value">
                      {orderDetails.trip_id === "" || orderDetails.trip_id === null ?
                       <Link  to={"#"}>
                      {orderDetails.trip_id ?? "-"}
                      </Link> 
                      : <Link  to={"/ViewDispatchTrip/" + orderDetails.trip_id}>
                      {orderDetails.trip_id ?? "-"}
                      </Link>}
                      
                      </p>
                    </div>
                    <div className="col-md-4">
                      <label className="head">{t("Trip Time")} </label>
                      <p className="Value">
                        {orderDetails?.trip_time ??
                          "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div
                className="main-master-wrapper form_input_main"
                id="View_Dispatch_main"
              >
                <div className="headingDetails">
                  <div className="headingTxt">
                    <p className="heading">{t("Assigned Driver & Vehicle Details")} </p>
                  </div>
                </div>
                <div className="DetailsSec">
                  <div className="row">
                    <div className="col-3">
                      <label className="head">{t("Driver Name")} </label>
                      <p className="Value">{orderDetails?.driver_name ?? "-"}</p>
                    </div>
                    <div className="col-3">
                      <label className="head">{t("Driver Contact")} </label>
                      <p className="Value">
                        {orderDetails?.driver_mobile ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <label className="head">{t("Vehicle Category")} </label>
                      <p className="Value">
                        {orderDetails?.vehicle_type_description ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <label className="head">{t("Vehicle Name")} </label>
                      <p className="Value">
                        {orderDetails?.vehicle_number ?? "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* Order menu Map */}
              {/* <div className="DispatchMenuMap">
                <div className="mainMape">
                  <div className="map-main">
                    <MapComponent
                      componentId={"ViewOrders"}
                      data={orderDetails}
                      
                      viewTripVehicle={(orderDetails?.dispatch_package_status==1 ||orderDetails?.dispatch_package_status==2 ||orderDetails?.dispatch_package_status==3||orderDetails?.dispatch_package_status==4)?liveVehicleDetails:{latitude:"",
                        longitude:""}}
                    />
                    <div className="flagComments">
                      <div className="me-2">
                        <img src={flagLine} alt="" />
                        <label>{t("Start Point")} </label>
                      </div>
                      <img src={flagFill} alt="" />
                      <label>{t("End Point")} </label>
                    </div>
                  </div>
                </div>
              </div> */}

            </>
          )}
        </div>

        {loading1 ? (
          <Loader />
        ) : (
          <>
            {" "}
            <div
              className="modal  pm-body"
              style={{
                display: modelstats > 0 ? "block" : "none",
              }}
              id="modal-on-map"
            // onClick={() => {
            //   setMapLatLngData([]);
            // }}
            >
              <Modal.Dialog
                className="popover-main-wrapperHot"
                style={{ top: "20%" }}
              >
                <Modal.Header>
                  <Modal.Title className="headingHot d-flex flex-column">
                    {/* <p style={{color:"#8f4300"}}> */}
                    {t("Assign Order")}
                    {/* </p> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="headerFlex"
                    >
                      <p>
                        {" "}
                        <label className="greenDot"></label>{t("online")}
                      </p>
                      <p>
                        {" "}
                        <label className="redDot"></label>{t("Busy")}
                      </p>
                      <p>
                        {" "}
                        <label className="greyDot"></label>{t("Offline")}
                      </p>
                    </div>
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Form
                  // noValidate
                  // validated={validated}
                  // onSubmit={handleSubmit}
                  >
                    <div className="row">
                      <div className="col-md-12 form_input_main mt-3">
                        <div className="innerSelectBox weekCounter">
                          <Form.Label className="common-labels">
                            {t("Vehicle & Driver")}
                          </Form.Label>

                          <CommonSelect
                            setterKey={"vehicle_id"}
                            componentId={true}
                            setID={true}
                            setErrMsg={setErrMsg}
                            errMsg={errMsg}
                            errKey={"manual"}
                            setterFucntions={setRoutingData}
                            data={routingData}
                            selectedValue={routingData?.vehicle_id}
                            selValue={routingData?.vehicle_id}
                            setid={true}
                            optionList={
                              vehicleList &&
                              vehicleList?.map((single) => ({
                                id: single?.vehicle_id,
                                value: single?.vehicle_number,
                                label: (
                                  <div className="d-flex me-2">
                                    <div
                                      style={{
                                        backgroundColor:
                                          single?.metering_status == "T" ? "red" : single?.metering_status == "B"
                                            ? "green"
                                            : "grey", // Set your desired background color here
                                        width: "10px", // Set your desired width here
                                        height: "10px", // Set your desired height here
                                        borderRadius: "50%", // Make it a circle
                                        marginRight: "10px", // Set the space between the circle and the text
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    ></div>
                                    {/* <img src="https://via.placeholder.com/30x30" alt="Vanilla" /> */}
                                    {`${single?.vehicle_number} >> ${single?.user_name
                                      ? single?.user_name
                                      : `${t("No Driver Available")}`
                                      }`}
                                  </div>
                                ),

                                // `${single?.vehicle_number} >> ${single?.user_name?single?.user_name:"No Driver Available"}`
                              }))
                            }
                          />
                          {errMsg?.vehicle_id?.length > 0 && (
                            <span className="text-danger">
                              {errMsg?.vehicle_id}
                            </span>
                          )}
                          <Form.Control.Feedback>
                            {t("Please Select Vehicle...")}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      {/* <div className="col-md-12  form_input_main">

                    <div className="innerSelectBox weekCounter">
                      <Form.Label className="common-labels">
                        {t("Driver with vehicle")}
                      </Form.Label>
                   
                      <div>
                      {driver?.user_name && driver?.vehicle_number && (
                            <span
                              style={{ color: "#9c4900" }}
                            >{`${driver?.user_name}>>${driver?.vehicle_number}`}</span>
                          )}
                      </div>
                    
                    </div>
                  </div> */}
                      {/* <div className="col-md-12 col-lg-6 form_input_main">
                        <div className="innerSelectBox weekCounter">
                          <Form.Label className="common-labels">
                            {t("Start Time")}
                          </Form.Label>
                          <Space>
                            <TimePicker
                              className="form-control carretClass"
                              size="large"
                              allowClear={true}
                              value={
                                routingData?.trip_start_time &&
                                dayjs(routingData?.trip_start_time, "HH:mm:ss")
                              }
                              showNow={false}
                              // showNow={()=>{
                              //      const currentTime = new Date()
                              //     .toLocaleTimeString("en-US", { timeZone, hour12: false })
                              //    .split(" ")[0];
                              //     setRoutingData({ ...routingData, trip_start_time:currentTime, });
                              //                         }}
                    // locale={}
                              onChange={(e) => {
                                if (e) {
                                  const currentTime = dayjs();
                                  const selectedTime = dayjs(
                                    e.format("HH:mm:ss"),
                                    "HH:mm:ss"
                                  );
                                  const differenceInMinutes = selectedTime?.diff(
                                    currentTime,
                                    "minute"
                                  );
                                  if (
                                    selectedTime?.isAfter(currentTime) ||
                                    selectedTime?.isSame(currentTime) ||
                                    differenceInMinutes >= -120
                                  ) {
                                    let time =
                                      e.hour() +
                                      ":" +
                                      e.minute() +
                                      ":" +
                                      e.second();
                                    setRoutingData({
                                      ...routingData,
                                      trip_start_time: time,
                                    });
                                  } else {
                                    setRoutingData({
                                      ...routingData,
                                      trip_start_time: "",
                                    });
                                  }
                                }
                                // else {
                                //   setRoutingData({
                                //     ...routingData,
                                //     trip_start_time: "",
                                //   });
                                // }
                                setErrMsg({ ...errMsg, trip_start_time: "" });
                              }}
                            />
                            {errMsg?.trip_start_time??.length > 0 && (
                              <span className="text-danger">
                                {errMsg?.trip_start_time}
                              </span>
                            )}
                          </Space>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-6 form_input_main">
                        <div className="innerSelectBox weekCounter">
                          <Form.Label className="common-labels">
                            {t("End Time")}
                          </Form.Label>
                          <Space>
                            <TimePicker
                              className="form-control carretClass"
                              size="large"
                              allowClear={true}
                              value={
                                routingData?.trip_end_time &&
                                dayjs(routingData?.trip_end_time, "HH:mm:ss")
                              }
                              showNow={false}
                              onChange={(e) => {
                                if (e) {
                                  let time =
                                    e.hour() +
                                    ":" +
                                    e.minute() +
                                    ":" +
                                    e.second();
                                  setRoutingData({
                                    ...routingData,
                                    trip_end_time: time,
                                  });
                                } else {
                                  setRoutingData({
                                    ...routingData,
                                    trip_end_time: "",
                                  });
                                }
                                setErrMsg({ ...errMsg, trip_end_time: "" });
                              }}
                            />
                          </Space>
                          {errMsg?.trip_end_time??.length > 0 && (
                            <span className="text-danger">
                              {errMsg?.trip_end_time}
                            </span>
                          )}
                        </div>
                      </div> */}
                    </div>
                    <Modal.Footer>
                      <div className="d-flex justify-content-end align-items-center belowBtns btn-wrapper">
                        <button
                          type="button"
                          onClick={() => {
                            handleCancle();
                            handleModel(false);
                            setRoutingData({
                              trip_end_time: "",
                              trip_start_time: "",
                              vehicle_id: "",
                            });
                          }}
                          className="cx-btn-1"
                        >
                          {t("Cancel")}
                        </button>
                        <button
                          type="button"
                          onClick={() => handalevalidation()}
                          className="cx-btn-2"
                        >
                          {t("Assign Trip")}
                        </button>
                      </div>
                    </Modal.Footer>
                  </Form>
                </Modal.Body>
              </Modal.Dialog>
            </div>
          </>
        )}
      </motion.div>
    </>
  );
};

export default DispatchViewOrder;
